import {Transform} from '@/ui/blocks/transform';
import type {TransformFeature} from '@/ui/blocks/transform';
import {useTranslation} from 'react-i18next';
import {Heart, Package, Zap} from'lucide-react';

const FEATURES: Omit<TransformFeature, 'title' | 'description'>[] = [
  {
    number:'01',
    icon: Zap,
    gradient:'from-rose-500/20 via-pink-500/20 to-fuchsia-500/20',
    iconGradient:'from-rose-400 to-pink-500',
    borderGradient:'from-rose-500/50 via-pink-500/30 to-transparent',
    glowColor:'rose',
  },
  {
    number:'02',
    icon: Package,
    gradient:'from-violet-500/20 via-purple-500/20 to-indigo-500/20',
    iconGradient:'from-violet-400 to-purple-500',
    borderGradient:'from-violet-500/50 via-purple-500/30 to-transparent',
    glowColor:'violet',
  },
  {
    number:'03',
    icon: Heart,
    gradient:'from-emerald-500/20 via-teal-500/20 to-cyan-500/20',
    iconGradient:'from-emerald-400 to-teal-500',
    borderGradient:'from-emerald-500/50 via-teal-500/30 to-transparent',
    glowColor:'emerald',
  },
] as const;

export const TransformSection = (): React.ReactElement => {
  const { t } = useTranslation();

  const features: TransformFeature[] = FEATURES.map((feature, index) => ({
    ...feature,
    title: t(`ui.transform.feature${index + 1}.title`),
    description: t(`ui.transform.feature${index + 1}.description`),
  }));

  return (
    <Transform
      intro={t('ui.transform.intro','Why Tangi?')}
      titleLine1={t('ui.transform.titleLine1')}
      titleLine2={t('ui.transform.titleLine2')}
      features={features}
    />
  );
};
